import { render, staticRenderFns } from "./PerformanceSystemDetail.vue?vue&type=template&id=47ff4fd4&scoped=true"
import script from "./PerformanceSystemDetail.vue?vue&type=script&lang=js"
export * from "./PerformanceSystemDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ff4fd4",
  null
  
)

export default component.exports